export const TerminationTypes = {
    EndCollaborationWithoutTerminatingService: 0,
    EndCollaborationAndTerminateServiceOnMonthEnd: 1,
    EndCollaborationWithImmediateServiceTermination: 2,
    EndCollaborationAndTerminateServiceAtCurrentPeriodEnd: 3
}